import { IExcelService } from "./ExcelService.types";
import { ExcelServiceApi } from "./services";
import { ImportProtokoll } from "./model";
import { ImportProtokollApi } from "./ImportProtokollApi";
import { ISpringRestParam } from "@oceanjs/core";
import { PageResult, SortInfo } from "./Service.types";
import { handleServiceError } from "./ServiceUtil";
import { ServiceError } from "./errors";

class ExeclServiceImpl implements IExcelService {

  async uploadExcel(file: File, email: string): Promise<ImportProtokoll> {

    const result = await ExcelServiceApi.uploadExcelFile(file, email, handleServiceError);
    if(result) {
      return result?.data;
    }
    throw new ServiceError(500, {message: 'Unbekannter Fehler', status: 500});
  }

  async getUploadProtocol(pageSize: number, pageIndex: number, sortBy: SortInfo[]): Promise<PageResult<ImportProtokoll>> {

    const sort: string[] = [];
    sortBy.forEach( s => {
      sort.push(s.desc ? `${s.id},desc` : `${s.id}`);
    });
    const params: ISpringRestParam = { page: pageIndex, size: pageSize, sort};

    const result = await ImportProtokollApi.findAll(params);

    console.log(result);
    if (result) {
      return { list: result.data.list, page: result.data.page, links: result.data.links }
    }
    return { list: [], page: {size: 0, totalElements: 0, totalPages: 0, number: 0} };
  }

  async getUploadExcelFile(id: number): Promise<any> {
    return ExcelServiceApi.getExcelFile(id);
  }

  async getUploadExcelProtocol(id: number): Promise<any> {
    return ExcelServiceApi.getExcelFileProtocol(id);
  }

  async getExcelExport(): Promise<any> {
    return ExcelServiceApi.getExcelExport();
  }
}

export const ExcelService = new ExeclServiceImpl();
